import { Assistants } from '../translations-types';

const translations: Assistants = {
  successfullyUpdatedAssistantsSettings: 'Successfully updated assistants Settings',
  creditsOptions: 'Assistant credits purchase options',
  creditsBalance: 'Assistant credits balance',
  insufficientCredits: 'Insufficient Credits. Available: {{available}}, required: {{required}}.',
  noAssistants: 'No assistants available.',
};

export default translations;
